<template>
  <div class="border p-10">
    <span class="fs-14">{{getProductName(product)}}</span>
    <span class="fs-14" v-if="product.shortDescription"><br>{{product.shortDescription}}</span>
    <span class="fs-14" v-if="product.agency_rate==null"><br>{{ $t('products.priceField') }} {{$n(product.sellingUnitPrice,'currency','CAD')}}</span>
  </div>
</template>
<script>

import ProductUtil from '@/utils/product-util'

export default {
  name: 'ProductSummary',
	props: {
		product : Object,

	},
  data() {
    return {

    };
  },
  components: {

  },
	methods: {
    getProductName(product){
      return ProductUtil.productName(product);
    }
	},
	computed: {

	}
}
</script>
